import React, { useState, useEffect, ChangeEvent, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/Form/Input';
import Radio from '../../components/Form/Radio';
import Textarea from '../../components/Form/Textarea';
import Select from '../../components/Form/Select';
import Template from '../../components/Template';
import Alert from '../../helpers/Alert';

import moment from 'moment';

// SERVICES
import { newOs } from '../../services/OsService';
import { getUsers } from '../../services/UserService';
import { getDetailsAddress, getStreetView } from '../../services/LocationService';
import { getListInsurence } from '../../services/InsurenceCompanyService';
import { getListProperty } from '../../services/insurancePropertyService';
import { createFile, handleImage } from '../../services/FileService'
import { MdCancel } from 'react-icons/md'
import { GrDocument } from "react-icons/gr";
import i18n from 'translate/i18n';

interface TypeData {
  dateAreaSindicancia: string,
  datePrazo: string,
  analistaSinistro: string,
  seguradora: string,
  tipoSindicancia: string,
  sindicancia: string,
  segurado: string,
  vistoria: string,
  sinistro: string,
  bemSegurado: string,
  natureza: string,
  veiculo: string,
  placa: string,
  registro: string,
  causa: string,
  resultado: string,
  indenizacao: string,
  prioridade: string,
  search: string,
  location: any,
  endereco: string,
  locationFilename: string,
  registro_observacao: string,
}

interface TypeSelectData {
  _id: string,
  name: string,
}

interface TypePropertyData {
  _id: string,
  name: string,
  natureza: TypeSelectData[]
}
interface typeList {
  id: string,
  url: string,
  origin: string,
  file?: File,
  label?: string
}

export default function NewOS() {
  let history = useNavigate();

  moment.locale('pt-br');

  const [data, setData] = useState<TypeData>(
    {
      dateAreaSindicancia: '',
      datePrazo: '',
      analistaSinistro: '',
      seguradora: '',
      tipoSindicancia: '',
      sindicancia: '',
      segurado: '',
      vistoria: '',
      sinistro: '',
      bemSegurado: '',
      natureza: '',
      veiculo: '',
      placa: '',
      registro: '',
      causa: '',
      resultado: '',
      indenizacao: '',
      prioridade: '',
      search: '',
      location: '',
      endereco: '',
      locationFilename: '',
      registro_observacao: '',
    }
  );

  const [file, setFile] = useState<typeList[]>([])

  const [urlPhoto, setUrlPhoto] = useState<string>('')

  const [idPrestador, setIdPrestador] = useState<string>('')
  const [listInsurence, setListInsurence] = useState<TypeSelectData[]>([]);
  const [listProperty, setListProperty] = useState<TypePropertyData[]>([]);

  const [users, setUsers] = useState<any[]>([]);
  const [isAdmin, setIsAdmin] = useState<boolean>(false)

  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false)

  //busca perfil do usuario
  useEffect(() => {
    try {
      const user: any = localStorage.getItem('user');
      const { id, name, role } = JSON.parse(user);


      if (role !== 'manager' && role !== 'admin') {
        setIdPrestador(id)
      } else {
        setIsAdmin(true);
        getUsers().then(res => {
          const data = res.data.rows;
          const usersNew = data.map((user: any) => {
            return {
              _id: user.id,
              name: user.name
            }
          })
          setUsers(usersNew)
        })
      }
    }
    catch (err) {
      console.log(err)
    }
  }, [])

  useEffect(() => {
    //busca lista de seguradoras
    getListInsurence().then((res: TypeSelectData[]) => {
      setListInsurence(res)
    }).catch(err => console.log(err))

    //busca lista de bens do segurado
    getListProperty().then((res: TypePropertyData[]) => {
      setListProperty(res)
    }).catch(err => console.log(err))
  }, [])


  //atualiza variavel com dados dos select
  const handleSelectChange = (name: string, value: any) => {
    setData({ ...data, [name]: value });
  }

  //atualiza variavel com dados dos inputs
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };

  // submit
  const handleSubmit = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    setButtonDisabled(true)
    newOs({ ...data, prestador: idPrestador }).then(async res => {
      try {
        // Cria no BD os arquivos locais
        const dataLocalNew = file.filter((i: typeList) => i.origin === 'local');

        const createFilePromises = dataLocalNew.map(async ({ file, label }) => {
          if (file) {
            await createFile(file.name, res.data.id, 'registro', file, label);
          }
        });

        Alert(true, 'O.S. criada com sucesso!');
        await Promise.all(createFilePromises);
        // As operações assíncronas foram concluídas com sucesso

        history('/Home');
      } catch (error) {
        Alert(false, 'Erro inesperado ao salvar arquivos!');
      }
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.error) {
        const errorMessage = err.response.data.error;
        console.log('Erro:', errorMessage);
        Alert(false, errorMessage);
      } else {
        console.log('Erro:', err.message);
        Alert(false, 'Ocorreu um erro ao criar O.S.');
      }
      setButtonDisabled(false);
    });
  }

  // busca endereço e imagem do local
  const getAddress = () => {
    if (data.search) {
      getDetailsAddress(data.search).then((res: any) => {

        if (res.data.results[0]) {

          // buscar imagem
          const local = res.data.results[0]
          const { lat, lng } = local.geometry.location;

          getStreetView(`${lat},${lng}`).then((res: any) => {
            const { filename } = res.data;
            if (filename) {
              const img = `${process.env.REACT_APP_API_URL}/locations/streetview/${filename}`
              setUrlPhoto(img)
            }
            setData({ ...data, 'endereco': local.formatted_address, 'location': local, 'locationFilename': filename })
          });
        }
      })
        .catch((err) => {
          Alert(false, 'Local não encontrado');
        });
    }
  }

  // Atualiza prazo de entrega da O.S.
  /*
  useEffect(() => {
    const dataOs = moment().format('yyyy-MM-DD')
    let dias = 0;
    let diasUteis = 0;

    // se hora abertura OS < 18:00 | Previsão final = 00:00 d+1 + (3du)
    if (data.tipoSindicancia === 'remota' && moment(moment().format('yyyy-MM-DDThh:mm')).isBefore(moment(dataOs + 'T18:00'), 'hours')) {
      dias = 1
      diasUteis = 3
    }
    // se hora abertura OS  >= 18:00 | Previsão final = 00:00 d+2 + (3du)
    else if (data.tipoSindicancia === 'remota' && moment(moment().format('yyyy-MM-DDThh:mm')).isBefore(moment(dataOs + '23:59'), 'hours')) {
      dias = 2
      diasUteis = 3
    }
    // se hora abertura OS  < 12:00 | Previsão final = 00:00 d+1 + (5du)
    else if (data.tipoSindicancia === 'completa' && moment(moment().format('yyyy-MM-DDThh:mm')).isBefore(moment(dataOs + '12:00'), 'hours')) {
      dias = 1
      diasUteis = 5
    }
    // se hora abertura OS  >= 12:00 | Previsão final = 00:00 d+2 + (5du)
    else if (data.tipoSindicancia === 'completa' && moment(moment().format('yyyy-MM-DDThh:mm')).isBefore(moment(dataOs + '23:59'), 'hours')) {
      dias = 2
      diasUteis = 5
    }

    const newDate = moment().add(dias + diasUteis, 'days').format('yyyy-MM-DDT00:00:00')

    setData({ ...data, ['datePrazo']: newDate });
  }, [data.tipoSindicancia])
*/

  const setLocalFiles = async (e: ChangeEvent<HTMLInputElement>) => {
    const files = await handleImage(e, file);
    if (files) {
      setFile(files);
    }
  }

  // Funções que podem ser adicionadas na service files para serem reutilizadas - inicio


  // remove files localmente
  const removeFile = (url: string) => {
    const newData = file.filter((i: typeList) => i.url !== url)
    setFile(newData)
  }

  const handleAddLegend2Image = (item: typeList, label: string) => {
    const newData = file.map(dataItem => {
      if (dataItem.id === item.id) { dataItem.label = label }
      return dataItem
    })
    setFile(newData)
  }

  // Funções que podem ser adicionadas na service files para serem reutilizadas - fim


  return (
    <Template path={'Nova O.S.'}>
      <div className='container'>
        <div className='container-box col-md-12'>
          <fieldset>
            <form onSubmit={handleSubmit}>
              {
                isAdmin &&
                <Select
                  title="Designar Processo para Sindicante"
                  data={users}
                  value={idPrestador}
                  setSelected={setIdPrestador}
                  required={true}
                />
              }
              <Radio
                title="Tipo de sindicância"
                data={[
                  { _id: 'remota', name: 'Remota' },
                  { _id: 'pericia', name: 'Perícia' },
                  { _id: 'completa', name: 'Completa' },
                ]}
                value={data?.tipoSindicancia || ''}
                setSelected={(value: string) => { handleSelectChange('tipoSindicancia', value) }}
              />
              <Input
                name="dateAreaSindicancia"
                label="Data de entrada na área de sindicância"
                type="datetime-local"
                placeholder={'Data de entrada na área de sindicância'}
                data={moment(data?.dateAreaSindicancia).format('yyyy-MM-DDTHH:mm')}
                setData={handleInputChange}
                required={true}
              />
              {/*
              <Input
                name="datePrazo"
                label="Previsão para entrega da O.S."
                type="datetime-local"
                placeholder={'Previsão para entrega da O.S.'}
                data={data.datePrazo}
                setData={handleInputChange}
              />
              */}
              <Input
                name="analistaSinistro"
                label="Analista responsável (área de sinistros)"
                type="text"
                placeholder={'Nome do analista responsável (área de sinistros)'}
                data={data?.analistaSinistro || ''}
                setData={handleInputChange}
              />
              <Select
                title="Seguradora"
                data={listInsurence}
                value={data?.seguradora}
                setSelected={(value: string) => { handleSelectChange('seguradora', value) }}
              />
              <Input
                name="sindicancia"
                label="Código da Sindicância"
                type="text"
                placeholder={'Sindicância'}
                data={data?.sindicancia || ''}
                setData={handleInputChange}
              />
              <Input
                name="segurado"
                label="Nome do Segurado"
                type="text"
                placeholder={'Segurado'}
                data={data?.segurado || ''}
                setData={handleInputChange}
              />
              <Input
                name="vistoria"
                label="Código da Vistoria"
                type="text"
                placeholder={'Vistoria'}
                data={data?.vistoria || ''}
                setData={handleInputChange}
              />
              <Input
                name="sinistro"
                label="Código do Sinistro"
                type="text"
                placeholder={'Sinistro'}
                data={data?.sinistro || ''}
                setData={handleInputChange}
              />
              <Select
                title="Bem Segurado"
                data={
                  listProperty.map((a: TypePropertyData) => {
                    return { _id: a._id, name: a.name }
                  })
                }
                value={data?.bemSegurado}
                setSelected={(value: string) => { handleSelectChange('bemSegurado', value) }}
              />

              <Input
                name="natureza"
                label="Natureza"
                type="text"
                placeholder={'Natureza'}
                data={data?.natureza || ''}
                setData={handleInputChange}
              />

              <Input
                name="veiculo"
                label="Veículo"
                type="text"
                placeholder={'Veículo'}
                data={data?.veiculo || ''}
                setData={handleInputChange}
              />

              <Input
                name="placa"
                label="Placa"
                type="text"
                placeholder={'Placa'}
                data={data?.placa || ''}
                setData={handleInputChange}
              />

              <Input
                name="indenizacao"
                label="Indenização"
                type="text"
                placeholder={'Indenização'}
                data={data?.indenizacao || ''}
                setData={handleInputChange}
              />

              <Radio
                title="Prioridade"
                data={[
                  { _id: 'Regular', name: 'Regular' },
                  { _id: 'Alta', name: 'Alta' },
                ]}
                value={data?.prioridade || ''}
                setSelected={(value: string) => { handleSelectChange('prioridade', value) }}
              />
              {/*
              <Textarea
                name="causa"
                label="Causa"
                placeholder={'Causa'}
                data={data?.causa || ''}
                setData={handleInputChange}
              />

              <Input
                name="resultado"
                label="Resultado"
                type="text"
                placeholder={'Resultado'}
                data={data?.resultado || ''}
                setData={handleInputChange}
              />
            */}

              <div className='field-inline'>

                <Input
                  name="search"
                  label="Pesquisar local"
                  type="text"
                  placeholder={'Pesquise pelo CEP ou digite o endereço completo'}
                  data={data?.search || ''}
                  setData={handleInputChange}
                  required={false}
                />
                <div className='field'>
                  <label> </label>
                  <button className='btn btn-secundary' onClick={(event: MouseEvent<HTMLButtonElement>) => { event.preventDefault(); getAddress() }}>Procurar</button>
                </div>
              </div>
              <Input
                name="endereco"
                label="Endereço"
                type="text"
                placeholder={'Endereco'}
                data={data?.endereco || ''}
                setData={handleInputChange}
                disabled={true}
              />
              {urlPhoto.length > 0 &&
                <img src={urlPhoto} alt="foto-local" width='100%' />
              }

              <Textarea
                name="registro_observacao"
                label="Observações"
                placeholder={'Observações'}
                data={data?.registro_observacao || ''}
                setData={handleInputChange}
                required={false}
              />

              <>
                <h5 style={{ marginTop: 15 }}>{i18n.t<string>('edit.files')}</h5>
                <div className="field">
                  <label htmlFor="label">Inserir imagens e/ou documentos dos tipos: PNG, JPEG, JPG e PDF:</label>
                  <input type="file"
                    onClick={(e: any) => (e.target.value = null)}
                    name="images"
                    accept='image/png, image/jpeg, image/jpg, application/pdf'
                    multiple
                    onChange={async e => await setLocalFiles(e)}
                  />
                </div>
                <div className="field">
                  <div id='list-images'>
                    {
                      file?.sort((a: typeList, b: typeList) => a.id.localeCompare(b.id)).map((item: typeList) =>
                        <div key={item.id}>
                          {
                            (
                              item.file?.name.includes('.pdf') ||
                              item.url.includes('.pdf')
                            )
                            &&
                            <>
                              <span className='item' >
                                <MdCancel className='item-icon' onClick={() => { removeFile(item.url) }} />
                                <GrDocument style={{ fontSize: 50 }} />
                                <input value={item.label} style={{ width: "100%" }} type="text" placeholder="Digite uma legenda" onChange={(event) => handleAddLegend2Image(item, event.target.value)} />
                              </span>
                            </>
                          }

                          {
                            (
                              !item.file?.name.includes('.pdf') &&
                              !item.url.includes('.pdf')
                            )
                            &&
                            <>
                              <span className='item' >
                                <MdCancel className='item-icon' onClick={() => { removeFile(item.url) }} />
                                <img src={item.url} />
                              </span>
                              <input value={item.label} style={{ width: "100%" }} type="text" placeholder="Digite uma legenda" onChange={(event) => handleAddLegend2Image(item, event.target.value)} />
                            </>
                          }
                        </div>
                      )

                    }
                  </div>
                </div>
              </>

              <button className='btn btn-primary' disabled={buttonDisabled}>Criar</button>
            </form>
          </fieldset>
        </div>
      </div>
    </Template>
  )
}
